import React, { Component } from 'react';
import PropTypes from "prop-types";
import NotificationSystem from 'react-notification-system';
import { _addNotification, _addNotificationError, groupBy } from '../../../../../../src/server/util';
import ReactTable from 'react-table';
import Select from 'react-select';
import { BeatLoader } from 'react-spinners';
import { get } from "../../../../../../src/server/actions"
import moment from 'moment';
import { date_format } from '../../../../../../src/server/constants';
import DateTimeRangePicker from '../../../../Misc/DateTimeRangePicker';

class PendingTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            selectedSchool: {},
            parentEmail: '',
            pendingTransactions: [],
            schoolList: [],
            selectedDates: {
                // startDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).startOf('month'),
                // endDate:moment(moment((this.props.activeMonth||moment()),'YYYYMM')).endOf('month'),
                startDate: moment().startOf('month'), // Store as moment object
                endDate: moment().endOf('month')
            },
        }
    }
    componentDidMount() {
        this.getSchoolList();
        // this.getPaymentInfoBySearch();
    }
    getSchoolList = () => {
        this.state.schoolList = [];
        get('/mealSchools/search/findByIsActive?isActive=true&page=0&size=2147483647&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log('Json returned from getSchoolList', data);
            this.setState({
                schoolList: data._embedded.mealSchools
            });
        })
            .catch(
                (error) => {
                    console.log('Get SchoolList response', error)
                }
            )
    };

    getPaymentInfoBySearch = () => {
        this.setState({ loading: true })
        let schoolId = Number((this.state.selectedSchool || {}).value || 0);
        schoolId = isNaN(schoolId) ? 0 : schoolId;
        let parentEmail = this.state.parentEmail || '';
        let url = `/pendingTransactions`;
        if (schoolId > 0 && parentEmail.length > 0 && (this.state.selectedDates.startDate > 0 && this.state.selectedDates.endDate > 0)) {
            url = url + `?mealSchoolId=${schoolId}&parentEmail=${parentEmail}&startDate=${moment(this.state.selectedDates.startDate).utc().format("YYYY-MM-DD")}&endDate=${moment(this.state.selectedDates.endDate).utc().format("YYYY-MM-DD")}&access_token=`;
        } else {
            if (schoolId > 0) {
                url = url + `?mealSchoolId=${schoolId}&startDate=${moment(this.state.selectedDates.startDate).utc().format("YYYY-MM-DD")}&endDate=${moment(this.state.selectedDates.endDate).utc().format("YYYY-MM-DD")}&access_token=`;
            } else if (parentEmail.length > 0) {
                url = url + `?parentEmail=${parentEmail}&startDate=${moment(this.state.selectedDates.startDate).utc().format("YYYY-MM-DD")}&endDate=${moment(this.state.selectedDates.endDate).utc().format("YYYY-MM-DD")}&access_token=`;
            } else {
                url = url + `?startDate=${moment(this.state.selectedDates.startDate).utc().format("YYYY-MM-DD")}&endDate=${moment(this.state.selectedDates.endDate).utc().format("YYYY-MM-DD")}&access_token=`;
            }
        }

        get(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.setState({ pendingTransactions: data.resp, loading: false });
        })
            .catch(
                (error) => {
                    this.setState({ pendingTransactions: [], loading: false });
                }
            )
    }

    validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    }

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value }, () => {
            if (name === 'parentEmail') {
                if (value === '') {
                    // Clear the error message if the input is empty
                    this.setState({ emailError: '' });
                } else if (this.validateEmail(value)) {
                    // Clear the error message if the email is valid
                    this.setState({ emailError: '' });
                } else {
                    // Set the error message if the email is invalid
                    this.setState({ emailError: 'Invalid email address' });
                }
            }
        });
    }
    onChangeDateRange = (startDate, endDate) => {
        let _selectedDate = { startDate: startDate, endDate: endDate }
        this.setState({ selectedDates: _selectedDate });
    }

    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                        <BeatLoader
                            size={20}
                            color={'#ea7066'}
                            loading={this.state.loading}
                        />
                    </div>
                    <div className="container-full">
                        <div className="sectionTitle">
                            <h2>
                                <span>Stripe Transactions</span>
                            </h2>
                        </div>
                        <div className="row">
                            <div className='col-md-12'>
                                <div className="form-group row">
                                    <label htmlFor="studentId" style={{ marginTop: '8px' }} className="col-sm-1   control-label">School Id:</label>
                                    <div className='col-sm-3'>
                                        <Select
                                            value={this.state.selectedSchool}
                                            isClearable={true}
                                            options={this.state.schoolList.map(sch => {
                                                const sid = sch._links.self.href.split('/').pop();
                                                return { value: sid, label: sch.schoolName };
                                            })}
                                            onChange={(val) => {
                                                this.setState({ selectedSchool: val }, () => {
                                                    console.log("this.state.selectedSchool:::::", this.state.selectedSchool);
                                                });
                                            }}
                                        />
                                    </div>
                                    <label htmlFor="parentEmail" style={{ marginTop: '8px' }} className="col-sm-1 control-label">Parent Email:</label>
                                    <div className='col-sm-3'>
                                        <input type="text" className="form-control" value={this.state.parentEmail}
                                            name="parentEmail" placeholder="Search.." onChange={(e) => { this.handleChange(e) }}
                                            autoComplete="off"
                                        />
                                        {this.state.emailError && (
                                            <div style={{ color: 'red', marginTop: '5px' }}>
                                                {this.state.emailError}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className='col-md-12'>
                                <div className="panel-body">
                                    <div style={{ marginTop: '5px', marginBottom: '5px', marginLeft: '-2%', fontSize: '16px' }}>
                                        <div className='col-md-2'>
                                            <label>Select date range:</label>
                                        </div>
                                        <div className='col-md-4'>
                                            <DateTimeRangePicker
                                                startDate={this.state.selectedDates.startDate}
                                                endDate={this.state.selectedDates.endDate}
                                                dateFormat='MM/DD/YYYY'
                                                isReport={false}
                                                applyCallback={(event, picker) => {
                                                    this.onChangeDateRange(picker.startDate, picker.endDate)
                                                }}
                                                isDateShow={true} />
                                        </div>
                                    </div>
                                    <div className=" col-md-6" style={{ marginRight: '1%' }}>
                                        <button type="button" class="btn btn-danger btn-sm" style={{ margin: '0px', marginRight: '8px' }} onClick={() => {
                                            this.getPaymentInfoBySearch();
                                        }} ><span class="glyphicon glyphicon-search"></span> Search
                                        </button>
                                        <button type="button" class="btn btn-danger btn-sm" style={{ margin: '0px' }} onClick={() => {
                                            this.setState({
                                                selectedSchool: {}, parentEmail: '', pendingTransactions: [], selectedDates: {
                                                    startDate: moment().startOf('month'),
                                                    endDate: moment().endOf('month')
                                                }
                                            });
                                        }} ><span class="glyphicon glyphicon-remove-circle"></span> Clear
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className='row' style={{ marginTop: '5px' }}>
                            <div className="col-md-12 ">
                                <ReactTable
                                    data={this.state.pendingTransactions}
                                    columns={[
                                        // {
                                        //     Header: "Student Name", accessor: "studentInfo", style: { textAlign: 'center' }, Cell: ({ row }) => {
                                        //         return row._original.firstName + ' ' + row._original.lastName
                                        //     }
                                        // },
                                        { Header: "ID", width: 50, accessor: "id", style: { textAlign: 'center' } },
                                        { Header: "MealSchool Id", width: 150, accessor: "mealSchoolId", style: { textAlign: 'center' } },
                                        { Header: "School Name", width: 150, accessor: "schoolName", style: { textAlign: 'center' } },
                                        { Header: "Subdomain", width: 150, accessor: "subdomain", style: { textAlign: 'center' } },
                                        { Header: "User Email", width: 150, accessor: "userEmail", style: { textAlign: 'center' } },
                                        {
                                            Header: "Date", width: 150, accessor: "createdOn", style: { textAlign: 'center' },
                                            Cell: row => <span>{moment(row.original.createdOn).format('MM/DD/YYYY' + ' , ' + 'hh:mm:ss a')}</span>,
                                        },
                                        { Header: "Payment ID", width: 150, accessor: "paymentId", style: { textAlign: 'center' } },
                                        { Header: "Payment Secret ID", width: 150, accessor: "paymentSecretId", style: { textAlign: 'center' } },
                                        { Header: "Description", width: 150, accessor: "trxDesc", style: { textAlign: 'center' } },
                                        { Header: "Online Payment Type", width: 100, accessor: "onlinePaymentType", style: { textAlign: 'center' } },
                                        { Header: "Fees", width: 100, accessor: "transactionFees", style: { textAlign: 'center' } },
                                        { Header: "Total Transaction Amount", width: 100, accessor: "totalTransactionAmount", style: { textAlign: 'center' } },
                                        { Header: "App Fee Amount", width: 100, accessor: "appFeeAmount", style: { textAlign: 'center' } },
                                    ]}
                                    defaultPageSize={10}
                                    className="-striped -highlight rtTable-Order"
                                    noDataText='No data found'
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default PendingTransactions;




// WEBPACK FOOTER //
// ./src/components/SuperAdmin/Support/broadcastMessage/PendingTransactions/pendingStripeTransactions.jsx